import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../services/authService";
import Cookies from "js-cookie";

const user = JSON.parse(localStorage.getItem("user"));

const initialState = {
  user: user ? user : null,
  actualScore: 0,
  coins: 0,
  error: false,
  success: false,
  loading: true,
  isAuthenticated: false,
};

export const checkSession = createAsyncThunk("auth/checkSession", async (_, thunkAPI) => {
  try {
    const userInfo = await authService.getProfile(); // Pega os dados da sessão no backend
    return userInfo; // Retorna os dados do usuário
  } catch (error) {
    return thunkAPI.rejectWithValue(null); // Rejeita se não houver sessão
  }
});

// Register a user and sign in
export const register = createAsyncThunk(
  "auth/register",
  async (user, thunkAPI) => {
    const data = await authService.register(user);

    // Check for errors
    if (data.errors) {
      return thunkAPI.rejectWithValue(data.errors[0]);
    }

    thunkAPI.dispatch(authSlice.actions.setLoggingOut(true));

    return data;
  }
);

// Logout a user
export const logout = createAsyncThunk("user/logout", async (user, thunkAPI) => {
  try {
    // Envia a requisição com credenciais (cookies HttpOnly) automaticamente
    const data = await authService.logout(user, { withCredentials: true });

    if (data.errors) {
      return thunkAPI.rejectWithValue(data.errors[0]);
    }
    Cookies.remove('auth', { path: '/' });
    Cookies.remove('user', { path: '/' });

  }catch(error){
    return thunkAPI.rejectWithValue(error.message || "Erro ao efetuar logout.");
  }
});

// Sing in a user
export const login = createAsyncThunk("auth/login", async (user, thunkAPI) => {
  const data = await authService.login(user);

  // Check for errors
  if (data.errors) {
    return thunkAPI.rejectWithValue(data.errors[0]);
  }else if(data.code==="ERR_BAD_REQUEST"){
    return thunkAPI.rejectWithValue(data.message);
  }

  return await authService.getProfile();
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.isAuthenticated = false;
    },
    setScore: (state, action) => {
      state.actualScore = action.payload;
    },
    setCoins: (state, action) => {
      state.coins = action.payload;
    },
    updateCoins: (state, action) => {
      state.coins += action.payload;
    },
    incrementScore: (state, action) => {
      state.actualScore += action.payload;
    },
    setLoggingOut: (state, action) => {
      state.loggingOut = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(register.pending, (state) => {
        state.loading = true;
        state.isAuthenticated = false;
        state.error = null;
      })
      .addCase(register.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.isAuthenticated = true;
        state.error = null;
        state.user = action.payload;
      })
      .addCase(register.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isAuthenticated = false;
        state.user = null;
        state.logou = false;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.loading = false;
        state.success = true;
        state.auth = null;        
        state.error = null;
        state.isAuthenticated = false;
      })
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.user = action.payload;
        state.isAuthenticated = true;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.user = null;
      })
      .addCase(checkSession.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkSession.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload;
      })
      .addCase(checkSession.rejected, (state) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.user = null;
      });;
  },
});

export const { reset, setCoins, setScore, incrementScore, updateCoins, setLoggingOut  } = authSlice.actions;
export default authSlice.reducer;